export type AccountMenuLegalLink = {
  key: string;
  label: string;
  url: string;
};

export const DEFAULT_LEGAL_LINKS: AccountMenuLegalLink[] = [
  {
    key: 'cloudLicense',
    label: 'Cloud License Agreement',
    url: 'https://realwear.com/legal/cloud-license-agreement',
  },
  {
    key: 'termsOfSale',
    label: 'Terms of Sale',
    url: 'https://realwear.com/legal/terms-of-sale',
  },
  {
    key: 'privacyPolicy',
    label: 'Privacy Policy',
    url: 'https://realwear.com/legal/privacy-policy',
  },
  {
    key: 'dataProcessing',
    label: 'Data Processing Addendum',
    url: 'https://realwear.com/legal/data-processing-addendum',
  },
];
